import React, { useEffect, useState } from "react";
import "./ImageThumbReorderGrid.css";

export default function ImageThumbReorderGrid({ files, onReorder, onRemove }) {
  const [items, setItems] = useState([]); // { file, url }

  useEffect(() => {
    const u = (files || []).map((f) => ({
      file: f,
      url: URL.createObjectURL(f),
    }));
    setItems(u);
    return () => u.forEach((x) => URL.revokeObjectURL(x.url));
  }, [files]);

  return (
    <div className="itrg">
      {items.map((x, i) => (
        <div
          key={`${x.file.name}-${i}`}
          className="itrg-card"
          draggable
          onDragStart={(e) => e.dataTransfer.setData("text/plain", String(i))}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            const from = Number(e.dataTransfer.getData("text/plain"));
            const to = i;
            if (!Number.isNaN(from) && from !== to) onReorder(from, to);
          }}
        >
          <img className="itrg-img" src={x.url} alt={x.file.name} />
          <div className="itrg-name" title={x.file.name}>
            {x.file.name}
          </div>
          <button className="itrg-remove" onClick={() => onRemove(i)}>
            Retirer
          </button>
        </div>
      ))}
    </div>
  );
}
